var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 14.375C.747 14.375 0 13.535 0 12.5c0-1.036.746-1.875 1.667-1.875h21.666c.92 0 1.667.84 1.667 1.875 0 1.036-.746 1.875-1.667 1.875H1.667z"
  })));
}

export default SvgCommonIconMinus;